// Initialize Sentry before React mounts — reads DSN from <meta name="sentry-dsn">
require("react/lab/src/utils/sentry")

var ReactRailsUJS = require("react_ujs")
var myCustomContext = require.context("react/lab/src", true)
ReactRailsUJS.useContext(myCustomContext)



    function setEqualHeight() {
        
    }

    // Call the function once the DOM is fully loaded
    window.onload = setEqualHeight;

    // Optional: Call the function on window resize to ensure the height stays the same
    window.onresize = setEqualHeight;

setInterval(setEqualHeight, 1000);

